import * as React from 'react';
import { FormControl, InputLabel, Input, Button, Grid, Fab } from '@material-ui/core';
import AddQuestionComponent from './AddQuestionComponent';
import AddIcon from '@material-ui/icons/Add';
import CommonMenuComponent from '../common/menu/CommonMenuComponent';
import PullFromRepositoryComponent from './PullFromRepositoryComponent';
import { Guid } from 'guid-typescript';
import TextEditorComponent from '../common/editor/TextEditorComponent';
import ConfirmationComponent from 'src/components/common//notification/ConfirmationComponent';
import { CLUSTER_DELETE_CONFIRAMATION } from '../../constants/NotificationMessageConstant';

const menuItems: any = [
    {
        text: 'Question from repository',
        clickIdentifier: 'Repository',
        icon: undefined,
        customCss: ''
    }
];

export default class AddClusterComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            cluster: {},
            questions: [],
            clusterIndex: 0,
            clusterName: '',
            clusterDescription: '',
            allData: {},
            errors: {},
            openMenu: false,
            showDialog: false,
            deleteCluster:false
        }

        this.handleClusterName = this.handleClusterName.bind(this);
        this.handleClusterDescription = this.handleClusterDescription.bind(this);
        this.addQuestion = this.addQuestion.bind(this);
        this.updateModule = this.updateModule.bind(this);
        this.handleMenuItem = this.handleMenuItem.bind(this);
        this.handleAddRepositoryQuestion = this.handleAddRepositoryQuestion.bind(this);
        this.onBlurHandleClusterName = this.onBlurHandleClusterName.bind(this);
        this.onBluHandleClusterDescription = this.onBluHandleClusterDescription.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.updateHtmlFromEditor = this.updateHtmlFromEditor.bind(this);
    }

    updateModule(data: any) {
        this.props.updateModule(data);
    }

    handleClusterDescription(e: any) {
        this.setState({
            clusterDescription: e.target.value
        });
    }

    onBluHandleClusterDescription = () => {
        this.props.updateModule({ data: { clusterIndex: this.state.clusterIndex, pageNumber: this.props.pageNumber, value: this.state.clusterDescription }, field: 'clusterDescription' });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        const checkClusterDescription = nextProps.cluster.cluster_description && nextProps.cluster.cluster_description.en;
        this.setState({
            cluster: nextProps.cluster,
            questions: nextProps.cluster.questions,
            clusterIndex: nextProps.clusterIndex,
            clusterName: nextProps.cluster.title.en,
            clusterDescription: checkClusterDescription === '<p><br></p>' ? '' : checkClusterDescription,
            allData: nextProps.allData,
            errors: nextProps.errors
        });
    }

    UNSAFE_componentWillMount() {
        this.setState({
            cluster: this.props.cluster,
            questions: this.props.cluster.questions,
            clusterIndex: this.props.clusterIndex,
            clusterName: this.props.cluster.title.en,
            clusterDescription: this.props.cluster.cluster_description.en,
            allData: this.props.allData,
            errors: this.props.errors
        });
    }

    addQuestion(index: any) {
        this.props.updateModule({ data: { clusterIndex: index, pageNumber: this.props.pageNumber }, field: 'addQuestion' })
    }

    handleClusterName(e: any) {
        this.setState({
            clusterName: e.target.value
        });
    }

    onBlurHandleClusterName = () => {
        this.props.updateModule({ data: { clusterIndex: this.state.clusterIndex, pageNumber: this.props.pageNumber, value: this.state.clusterName }, field: 'clusterName' })
    }

    handleAddRepositoryQuestion = () => {
        this.setState({ openMenu: true });
    }

    handleMenuItem = (action: any) => {
        switch (action) {
            case 'Repository':
                this.openPullFromRepositoryWindow();
                break;
        }
    }

    openPullFromRepositoryWindow = () => {
        this.setState({ showDialog: true, openMenu: false })
    }

    onDialogClose = () => {
        this.setState({ showDialog: false });
    }

    handleOutsideClick() {
        this.setState({ openMenu: false });
    }

    updateHtmlFromEditor(htmlData: any) {
        if (htmlData) {
            htmlData = htmlData.replace(/<a/g, '<a target="_blank"');
            this.props.updateModule({ data: { clusterIndex: this.state.clusterIndex, pageNumber: this.props.pageNumber, value: htmlData.toString() }, field: 'clusterDescription' });
        }
    }

    // delete cluster
    deleteCluster = () => {
        this.setState({
            deleteCluster: true
        })
    }

    // close confirm dialog
    handleCloseConfirmation = () => {
        this.setState({
            deleteCluster: false
        })
    }

    // handle yes confim button click event
    handleDeleteClusterConfimYesButton = (clusterId: number) => {
        this.props.updateModule({
            data: {
                pageNumber: this.props.pageNumber && this.props.pageNumber,
                clusterIndex: this.props.clusterIndex,
            },
            field: 'deleteCluster'
        });

        setTimeout(() => this.props.onDeletePageChange(this.props.pageNumber), 100);
        this.handleCloseConfirmation()
    }

    render() {
        return (
            <>
                {
                    this.state.cluster &&
                    <div >
                        <Grid container={true} spacing={8} direction="row" justify="space-between" alignItems="center">
                            <Grid xs={12} item={true}>
                                <div>
                                    <Grid container={true} spacing={8}>
                                        <Grid xs={7} item={true}>
                                            <div>
                                                <FormControl margin="normal" required={false} fullWidth={true}>
                                                    <InputLabel htmlFor="clusterName">Cluster Name</InputLabel>
                                                    <Input id="clusterName"
                                                        value={this.state.clusterName ? this.state.clusterName : ''} name="clusterName"
                                                        onChange={this.handleClusterName}
                                                        onBlur={this.onBlurHandleClusterName}
                                                        multiline={true}
                                                    />
                                                </FormControl>
                                            </div>
                                        </Grid>
                                        <Grid xs={2} item={true} className="DeleteClusterAlign">
                                          
                                           <a href="javascript:void(0)" onClick={() => this.deleteCluster()}>Delete Cluster</a>                                                                               
                                          
                                            
                                             </Grid>
                                        <Grid xs={7} item={true}>
                                            <div>
                                                <FormControl margin="normal" required={false} fullWidth={true}>
                                                    <InputLabel htmlFor="clusterDescription">Cluster Description</InputLabel>
                                                </FormControl>
                                                <TextEditorComponent updateHtmlFromEditor={this.updateHtmlFromEditor} htmlInput={this.state.clusterDescription} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <div className="questions">
                                        {this.state.questions && this.state.questions.map((question: any, index: any) => {
                                            return <AddQuestionComponent
                                                question={question}
                                                qData={this.state.questions}
                                                key={'addQuestionComponent_' + index}
                                                questionIndex={index}
                                                updateModule={this.updateModule}
                                                pageNumber={this.props.pageNumber}
                                                clusterIndex={this.state.clusterIndex}
                                                moduleId={this.props.moduleId}
                                                allData={this.state.allData}
                                                errors={this.state.errors}
                                                onDeletePageChange={this.props.onDeletePageChange}
                                                userId={this.props.userId}
                                            />
                                        })}
                                    </div>
                                </div>
                            </Grid>
                            <Grid xs={1} item={true} >
                                &nbsp;
                            </Grid>
                            <Grid xs={6} item={true} alignItems="flex-end" alignContent="flex-end">
                                <Button size="medium" className="btn-blue addQuestion" variant="outlined" type="button" value="Add Question" color="default" onClick={this.addQuestion.bind(this, this.state.clusterIndex)}>Add Question</Button>
                            </Grid>
                        </Grid>
                        <Grid container={true} direction="row" justify="flex-end" alignItems="center">
                            <Grid item={true}>
                                {
                                    <CommonMenuComponent
                                        onClickAway={this.handleOutsideClick}
                                        key={`pull-repo_${this.props.pageNumber}${this.props.clusterIndex}${this.props.questionIndex}`}
                                        open={this.state.openMenu}
                                        icon={
                                            <Fab color='secondary' onClick={this.handleAddRepositoryQuestion}>
                                                <AddIcon />
                                            </Fab>
                                        }
                                        menuItems={menuItems} onMenuItemClicked={this.handleMenuItem}
                                    />
                                }
                                {
                                    this.state.showDialog && (
                                        <PullFromRepositoryComponent
                                            key={Guid.create().toString()}
                                            showDialog={this.state.showDialog}
                                            modules={this.props.modules}
                                            onDialogClose={this.onDialogClose}
                                            clusterIndex={this.props.clusterIndex}
                                            getModuleList={this.props.getModuleList}
                                            updateModule={this.updateModule}
                                            pageNumber={this.props.pageNumber}
                                            allData={this.props.allData}
                                        />
                                    )}
                            </Grid>
                        </Grid>
                        <ConfirmationComponent
                            handleDialogSubmit={() => this.handleDeleteClusterConfimYesButton(this.props.clusterIndex)}
                            message={CLUSTER_DELETE_CONFIRAMATION}
                            open={this.state.deleteCluster}
                            onCloseConfirmation={() => this.handleCloseConfirmation()}
                        />
                    </div>
                }
            </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/AddClusterComponent.tsx